import { render, staticRenderFns } from "./BienCard.vue?vue&type=template&id=da58baae&"
import script from "./BienCard.vue?vue&type=script&lang=js&"
export * from "./BienCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports